// Aurora Innovation, Inc. Proprietary and Confidential. Copyright 2026.
import { background } from '../../tokens/themeColors/background';
import { border } from '../../tokens/themeColors/border';
import { inverseBackground } from '../../tokens/themeColors/inverse';
import { text } from '../../tokens/themeColors/text';
export var toggleButtonColors = function(mode) {
    var bg = background(mode);
    var bd = border(mode);
    var tx = text(mode);
    var inverseBg = inverseBackground(mode);
    return {
        outlined: {
            default: {
                border: bd.default,
                text: tx.primary,
                hover: {
                    background: bg.state.hover0
                }
            },
            selected: {
                background: bg.state.selectedTransparent,
                border: bd.action200,
                text: tx.action100
            },
            disabled: {
                border: bd.soft,
                text: tx.disabled
            },
            // Figma: Button/Outlined/Active Disabled/* — selected toggles reuse Button's active set
            selectedDisabled: {
                background: bg.state.disabledTransparent,
                border: bd.heavy,
                text: tx.tertiary
            }
        },
        contained: {
            default: {
                background: inverseBg.level100,
                text: tx.action,
                hover: {
                    background: inverseBg.state.selected1
                }
            },
            selected: {
                background: bg.actionBold,
                text: tx.white
            },
            disabled: {
                background: bg.state.disabled2,
                text: tx.disabled
            },
            // Figma has no Toggle-specific contained Active Disabled token; this mirrors
            // Button/Contained/Active Disabled pending designer confirmation.
            selectedDisabled: {
                background: bg.state.disabled3,
                text: tx.tertiary
            }
        },
        text: {
            default: {
                text: tx.primary,
                hover: {
                    background: bg.state.hover0
                }
            },
            selected: {
                background: bg.state.selectedTransparent,
                text: tx.status.info
            },
            disabled: {
                text: tx.disabled
            },
            selectedDisabled: {
                background: bg.state.disabledTransparent,
                text: tx.tertiary
            }
        }
    };
};

//# sourceMappingURL=toggleButtonColors.js.map